import { render, staticRenderFns } from "./TruckReport.vue?vue&type=template&id=24d40142"
import script from "./TruckReport.vue?vue&type=script&lang=js"
export * from "./TruckReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports